'use strict';

/*global app*/
/*global services*/
/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global wrrSuccess*/
/*global statusReleaseNoteToControl*/

function CompletionService() {
  this.$container = $('body');

  this.params = {};
  this.releaseNoteInfo = {};
  this.releaseNoteRIDs = [];
  this.releaseNoteRIDsAll = [];
  this.scannedHandlingUnits = [];

  this.init();
}

CompletionService.prototype = $.extend({}, {
  constructor: 'CompletionService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.view-release-note-info', function () {
      _this.viewReleaseNoteInfo();

      return false;
    });

    _this.$container.on('click', '.completion-process__open', function () {
      _this.runCompletion();

      return false;
    });

    _this.$container.on('click', '.completion-process__continue', function () {
      _this.continueCompletion($(this));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  viewReleaseNoteInfo: function viewReleaseNoteInfo() {
    var _this = this;

    app.showMessageHtml(_this.releaseNoteInfo.Info);

    return _this;
  },

  setReleaseNoteRIDs: function setReleaseNoteRIDs(RIDs) {
    var _this = this;

    _this.releaseNoteRIDs = RIDs.slice();
    _this.releaseNoteRIDsAll = RIDs.slice();

    return _this;
  },

  getReleaseNoteInfo: function getReleaseNoteInfo(RID, callback) {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('completion:get_release_note_info', { RID: RID }, function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  scanHandlingUnits: function scanHandlingUnits(releaseNoteRID, requestedHandlingUnitsCount) {
    var _this = this;

    var message = app.t('completion_process.scan_handling_unit_to_joining');
    message = message.replace('{count}', _this.scannedHandlingUnits.length);
    message = message.replace('{required}', requestedHandlingUnitsCount);

    services.get('input-service').getValueWithRes(message, function (res, handlingUnit) {
      if (isEmpty(handlingUnit)) {
        //pokud nema nic nacteneho, tak se vrati zpet
        if (_this.scannedHandlingUnits.length === 0) {
          return _this.doProcessMergeReleaseNote(releaseNoteRID);
        } else if (_this.scannedHandlingUnits.length >= requestedHandlingUnitsCount) {
          return _this.processMergeReleaseNote();
        } else {
          return _this.scanHandlingUnits(releaseNoteRID, requestedHandlingUnitsCount);
        }
      } else if ($.inArray(handlingUnit.toLowerCase(), _this.scannedHandlingUnits) >= 0) {
        //pokud jsem jiz naskenoval, zopakouji
        return _this.scanHandlingUnits(releaseNoteRID, requestedHandlingUnitsCount);
      }

      app.getFormation('completion:join_handling_units', { RID: releaseNoteRID, HandlingUnit: handlingUnit }, function (res) {
        if (res.msg === 'SUCCESS') {
          _this.scannedHandlingUnits.push(handlingUnit.toLowerCase());

          _this.scanHandlingUnits(releaseNoteRID, requestedHandlingUnitsCount);
        } else {
          app.showMessageHtml(res.error, function () {
            _this.scanHandlingUnits(releaseNoteRID, requestedHandlingUnitsCount);
          });
        }
      });
    });

    return _this;
  },

  processOutgoingControlQuick: function processOutgoingControlQuick() {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('outgoing_control_process:process_quick', { JoiningSymbol: _this.params.joiningSymbol, WebDocumentRID: _this.params.webDocumentRID }, function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        if (!res.data.ControlResult) {
          services.get('output-service').showMessageHtml(res.data.Message, function () {
            invokeCallback(_this.params.callback);
          });
        } else {
          invokeCallback(_this.params.callback);
        }
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  processPackingPlace: function processPackingPlace() {
    var _this = this;

    //musim nahradit callback
    if (_this.params.isAllowedOutgoingControl) {
      var callback = _this.params.callback;
      _this.params.callback = function () {
        _this.params.callback = callback;
        _this.processOutgoingControlQuick();
      };
    }

    services.get('packing-place-service').addPackingPlace(_this.params);

    return _this;
  },

  doProcessMergeReleaseNote: function doProcessMergeReleaseNote(releaseNoteRID) {
    var _this = this;

    _this.scannedHandlingUnits = [];
    _this.getReleaseNoteInfo(releaseNoteRID, function (data) {
      _this.releaseNoteInfo = data;

      if (!data.IsAnyReleaseNote) {
        return _this.processMergeReleaseNote();
      }

      if ('isAllowedCancel' in _this.params && _this.params.isAllowedCancel) {
        app.confirmCancelHtml(data.Info, function (ret) {
          if (ret === null) {
            return;
          }

          if (!ret) {
            return _this.processMergeReleaseNote();
          }

          _this.scanHandlingUnits(releaseNoteRID, data.HandlingUnitsToCompletion);
        });
      } else {
        app.confirmHtml(data.Info, function (ret) {
          if (!ret && data.IsAnyToCompletion) {
            if (data.IsAllowedCancelCompletion) {
              return _this.processPackingPlace();
            }

            app.showMessageHtml(app.t('completion_process.can_not_cancel_process'), function () {
              _this.doProcessMergeReleaseNote(releaseNoteRID);
            });

            return _this;
          }

          if (!ret) {
            return _this.processMergeReleaseNote();
          }

          _this.scanHandlingUnits(releaseNoteRID, data.HandlingUnitsToCompletion);
        });
      }
    });

    return _this;
  },

  processMergeReleaseNote: function processMergeReleaseNote() {
    var _this = this;

    if (_this.releaseNoteRIDs.length === 0) {
      _this.processPackingPlace();

      return;
    }

    var releaseNoteRID = _this.releaseNoteRIDs.pop();
    _this.doProcessMergeReleaseNote(releaseNoteRID);

    return _this;
  },

  showDocumentsInfo: function showDocumentsInfo() {
    var _this = this;

    services.get('picking-service').getDocumentsInfo(_this.params.webDocumentRID, function (data) {
      app.showMessageHtml(data.info, function () {
        _this.processPackingPlace();
      });
    });

    return _this;
  },

  mergeHandlingUnits: function mergeHandlingUnits(params) {
    var _this = this;

    params.isAllowedCancel = false;
    _this.initCompletion(params);

    services.get('common-process-service').getDocumentsByWarehouseDocument(_this.params.webDocumentRID, function (data) {
      _this.setReleaseNoteRIDs(data.rids);
      if ($.inArray(app.param('active_area'), app.param('joining_areas')) >= 0) {
        _this.processMergeReleaseNote();
      }  else {
        _this.showDocumentsInfo();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  processCompletion: function processCompletion() {
    var _this = this;

    services.get('input-service').scanValue({ content: _this.params.message, asHtml: true }, function (handlingUnit) {
      if (isEmpty(handlingUnit)) {
        return;
      }

      if (handlingUnit.toLowerCase() !== _this.params.handlingUnit.toLowerCase()) {
        services.get('output-service').showMessage(app.t('completion_process.wrong_handling_unit') + ' ' + handlingUnit);
        return;
      }

      $.each(_this.params.releaseNotes, function (index, releaseNote) {
        _this.setReleaseNoteRIDs([releaseNote.RID]);
      });

      _this.processMergeReleaseNote();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  runCompletion: function runCompletion(params) {
    var _this = this;

    params = params || {};
    params.joiningSymbol = params.joiningSymbol || '';
    params.handlingUnit = params.handlingUnit || '';
    params.webDocumentRID = params.webDocumentRID || 0;
    params.isAllowedCancel = true;
    params.callback = function () {
      location.reload();
    };

    _this.initCompletion(params);

    app.getFormation('completion:get_completion_document', { JoiningSymbol: _this.params.joiningSymbol, HandlingUnit: _this.params.handlingUnit }, function (res) {
      if (res.msg === 'SUCCESS') {
        if (res.data.Result === wrrSuccess) {
          _this.params.joiningSymbol = res.data.JoiningSymbol;
          _this.params.handlingUnit = res.data.HandlingUnit;
          _this.params.area = res.data.Area;
          _this.params.status = statusReleaseNoteToControl;
          _this.params.message = res.data.Message;
          _this.params.releaseNotes = res.data.ReleaseNotes;

          _this.processCompletion();
        } else {
          app.viewErrorMessage(res.data.Message);
        }
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  continueCompletion: function continueCompletion($btn) {
    var _this = this;

    var params = {
      webDocumentRID: $btn.data('web_document_rid'),
      joiningSymbol: $btn.data('joining_symbol'),
      area: $btn.data('area'),
      callback: function () {
        location.reload();
      }
    };

    blockElement(_this.$container);
    _this.mergeHandlingUnits(params);

    return _this;
  },

  initCompletion: function initCompletion(params) {
    var _this = this;

    //zakazeme prenacitani stranky, protoze muze dojit prenacteni, kdyz nechceme
    app.setParam('is_allowed_reload_page', false);

    _this.params = params;

    if (!('isAllowedOutgoingControl' in _this.params)) {
      _this.params.isAllowedOutgoingControl = true;
    }

    _this.releaseNoteRIDs = [];
    _this.scannedHandlingUnits = [];

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
